// Utility functions for constructing Studio authentication URLs.
export const getStudioBaseUrl = () => process.env.REACT_APP_STUDIO_AUTH_URL;

// Constructs the URL for Studio authentication, optionally including a returnTo parameter.
export const getStudioAuthUrl = (path, options = {}) => {
  // Ensure the path starts with a slash for correct URL construction.
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  // Create the full authentication URL using the base URL and the normalized path.
  const studioAuthUrl = new URL(`/auth${normalizedPath}`, getStudioBaseUrl());

  // If returnTo is not explicitly set to false, include the returnTo parameter with the current origin.
  if (options.returnTo !== false) {
    studioAuthUrl.searchParams.set("returnTo", window.location.origin);
  }

  return studioAuthUrl.toString();
};
